<div class="folders-list container">
  <div class="content">
    <div #filters class="content-card filters">
      <div class="top">
        <div class="top__left">
          <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">{{ 'EDocumentsList.MultipleActions' | translate }}</button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="signSelected()"
              [disabled]="!isSignSelectedEnabled()"
              [matTooltip]="'EDocumentsList.SignTooltip' | translate"
              >
              <span>{{ 'EDocumentsList.Sign' | translate }}</span>
            </button>
            <button
              mat-menu-item
              (click)="exportSelected()"
              [disabled]="!isExportSelectedEnabled()"
              [matTooltip]="'EDocumentsList.ExportTooltip' | translate"
              >
              <span>{{ 'EDocumentsList.Export' | translate }} </span>
            </button>
            <button
              mat-menu-item
              (click)="deleteAndRecalculateSelected()"
              [disabled]="!isDeleteAndRecalculateSelectedEnabled()"
              [matTooltip]="'EDocumentsList.DeleteAndRecalculateNumerationTooltip' | translate"
              >
              <span>{{ 'EDocumentsList.DeleteAndRecalculateNumeration' | translate }} </span>
            </button>
            <button
              mat-menu-item
              (click)="deleteSelected()"
              [disabled]="!isDeleteSelectedEnabled()"
              [matTooltip]="'EDocumentsList.DeleteEFolderTooltip' | translate"
              >
              <span>{{ 'EDocumentsList.DeleteEFolder' | translate }} </span>
            </button>
          </mat-menu>
          <button mat-raised-button color="primary" class="add-document" (click)="openModal()">
            <span>{{ 'EDocumentsList.AddDocument' | translate }}</span>
          </button>
        </div>
        <div class="top__right">
          @if (showFilterPresetSelector) {
            <mat-form-field [@inOutAnimation] appearance="outline" class="filter-preset-selector">
              <mat-label>Filtr</mat-label>
              <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
                @for (preset of filterPresets; track preset) {
                  <mat-option [value]="preset.Id">{{
                    preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <button (click)="resetFilters()" class="top__button top__button-clear">
            <mat-icon>close</mat-icon>
            {{ 'Reset' | translate }}
          </button>
          <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
            <mat-icon>filter_alt</mat-icon>
            {{ 'Filter' | translate }}
          </button>
        </div>
      </div>
      @if (areFiltersExpanded) {
        <app-e-documents-list-filters [formGroup]="filtersFormGroup" (filterGridData)="filterData($event)">
          <div class="favorite-button-row-container">
            <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
              @if (isSavedFilterPreset) {
                <mat-icon>bookmark</mat-icon>
                {{ 'UnsaveFilter' | translate }}
              } @else {
                <mat-icon>bookmark_border</mat-icon>
                {{ 'SaveFilter' | translate }}
              }
            </button>
          </div>
        </app-e-documents-list-filters>
      }
    </div>

    <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
      <div #tableContainer class="wrapper custom-table">
        <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
          <mat-table
            class="table"
            matSort
            [matSortActive]="defaultSortColumn"
            [matSortDirection]="defaultSortDirection"
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="onSortChange()"
            >
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  appearance="outline"
                  (change)="onSelectAllChxChange()"
                  [checked]="dataSource.selection.hasValue() && isAllSelected()"
                  [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
                  [matTooltip]="'SelectAll' | translate"
                  matTooltipPosition="above"
                  >
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="onRowChxChange($event, row)"
                  [checked]="dataSource.selection.isSelected(row)"
                  >
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CompanyName">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'EDocumentsList.CompanyName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.CompanyName">{{ element.CompanyName }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="FullName">
              <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
                {{ 'EDocumentsList.FullName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a
                  class="user"
                  [routerLink]="['/profile/' + element.WorkerId]"
                  [matTooltip]="'WL-ShowWokerProfile' | translate"
                  matTooltipPosition="above"
                  >{{ element.LastName + ' ' + element.FirstName }}
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Pesel">
              <mat-header-cell *matHeaderCellDef mat-sort-header="DateOfBirth" class="hidden-sort">
                {{ 'EDocumentsList.Pesel' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.Pesel">{{ element.Pesel }}</span></mat-cell
                >
              </ng-container>

              <ng-container matColumnDef="DocumentId">
                <mat-header-cell *matHeaderCellDef mat-sort-header="DocumentId" class="hidden-sort">
                  {{ 'EDocumentsList.DocumentId' | translate }}
                  <app-table-header-sort></app-table-header-sort>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  ><span [matTooltip]="element.DocumentId">{{ element.DocumentId }}</span></mat-cell
                  >
                </ng-container>

                <ng-container matColumnDef="Part">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EDocumentsList.Part' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"
                    ><span [matTooltip]="element.Part">{{ element.DocumentPart }}</span></mat-cell
                    >
                  </ng-container>

                  <ng-container matColumnDef="Document">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                      {{ 'EDocumentsList.Document' | translate }}
                      <app-table-header-sort></app-table-header-sort>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"
                      ><span [matTooltip]="element.Document">{{ element.DocumentType }}</span></mat-cell
                      >
                    </ng-container>

                    <ng-container matColumnDef="AddedDate">
                      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                        {{ 'EDocumentsList.AddedDate' | translate }}
                        <app-table-header-sort></app-table-header-sort>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <span [matTooltip]="element.AddedDateTooltip">{{ element.AddedDate | date : 'yyyy-MM-dd' }}</span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="ValidUntilDate">
                      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                        {{ 'EDocumentsList.ValidUntilDate' | translate }}
                        <app-table-header-sort></app-table-header-sort>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <span [matTooltip]="element.ValidUntilDateTooltip">{{ element.ValidUntilDate | date : 'yyyy-MM-dd' }}</span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Comments">
                      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                        {{ 'EDocumentsList.Comments' | translate }}
                        <app-table-header-sort></app-table-header-sort>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <span [matTooltip]="element.Comments">{{ element.Comments }}</span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Actions">
                      <mat-header-cell *matHeaderCellDef>{{ 'WAD-Actions' | translate }}</mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="onShowFolderBtnClick(element)" matTooltipPosition="above">
                          <mat-icon class="material-icons-outlined">folder_shared</mat-icon>
                        </button>
                        <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                          <span>{{ 'Actions' | translate }}</span>
                          <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                        </button>
                        <mat-menu #menuRow="matMenu" panelClass="actions-menu">
                          <ng-container>
                            <button
                              mat-button
                              (click)="onPreviewBtnClick(element)"
                              [matTooltip]="'EDocumentsList.PreviewTooltip' | translate"
                              matTooltipPosition="above"
                              >
                              <mat-icon class="material-icons-outlined">visibility</mat-icon>
                              <span class="button-text">{{ 'EDocumentBufor.ShowDocument' | translate }}</span>
                            </button>
                          </ng-container>
                          <ng-container>
                            <button
                              mat-button
                              (click)="onEditBtnClick(element)"
                              [matTooltip]="'EDocumentsList.EditTooltip' | translate"
                              matTooltipPosition="above"
                              >
                              <mat-icon class="material-icons-outlined">create</mat-icon>
                              <span class="button-text">{{ 'EDocumentBufor.EditDocument' | translate }}</span>
                            </button>
                          </ng-container>
                          <ng-container>
                            <button
                              mat-button
                              (click)="onPreviewFileBtnClick(element)"
                              [matTooltip]="'EDocumentsList.FilePreviewTooltip' | translate"
                              matTooltipPosition="above"
                              >
                              <mat-icon class="material-icons-outlined">note_add</mat-icon>
                              <span class="button-text">{{ 'EDocumentBufor.File' | translate }}</span>
                            </button>
                          </ng-container>
                          <ng-container>
                            <button
                              mat-button
                              (click)="onDownloadBtnClick(element)"
                              [matTooltip]="'EDocumentsList.FileDownloadTooltip' | translate"
                              matTooltipPosition="above"
                              >
                              <mat-icon class="material-icons-outlined">file_download</mat-icon>
                              <span class="button-text">{{ 'EDocumentBufor.FileDownload' | translate }}</span>
                            </button>
                          </ng-container>
                          <ng-container>
                            <button
                              mat-button
                              (click)="onSendBtnClick(element)"
                              [matTooltip]="'EDocumentsList.ExportTooltip' | translate"
                              matTooltipPosition="above"
                              >
                              <mat-icon class="material-icons-outlined">arrow_right_alt</mat-icon>
                              <span class="button-text">{{ 'EDocumentsList.Export' | translate }}</span>
                            </button>
                          </ng-container>
                        </mat-menu>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="progress">
                      <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                        <mat-progress-bar [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'" class="table-progress" color="accent">
                        </mat-progress-bar>
                      </mat-header-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: sticky" [style.top.px]="offset$ | async"></mat-header-row>
                    <mat-header-row *matHeaderRowDef="['progress']; sticky: sticky" class="progress" [style.top.px]="(offset$ | async) + 56">
                    </mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                  </mat-table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
            <app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource.absoluteDataLength"></app-item-counter>
          </div>
        </div>
